import React from 'react';
import Markdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import styled from 'styled-components';

const MarkdownContainer = styled.div`
  font-family: Arial, sans-serif;
  color: #667;
  /* font-size: 16px; */
  line-height: 1.5;
  padding: 20px;
  h1{
    font-family: 'Runtoe';
    font-size: 4rem;
    /* color: #557; */
    color: var(--color-brand-900);
    margin-bottom: 1rem;
  }
  h2{
    color: #668;
  }
  h3{
    color: #779;
  }
  code{
        background-color: rgba(30, 30, 50, 0.06);
        border-radius: 3px;
        /* color: #A93226; */
        color: var(--color-brand-900);
        font-size: 1.2rem;
        font-weight: normal;
        padding: 0.1rem 0.4rem;
        margin: 0.6rem 0;
    }
  @media(max-width: 768px) {
    /* padding:  0; */

    h1{
        font-size: 3.2rem;
    }
    h2{
        font-size: 2.4rem;
    }
    h3{
        font-size: 2rem;
    }
    code{
        border-radius: 3px;
        font-size: 1.4rem;
    }
  }
  @media(max-width: 600px) {
    font-size: 1.4rem;
    padding: 0;
    h1{
        font-size: 2.4rem;
    }
    h2{
        font-size: 2rem;
    }
    h3{
        font-size: 1.6rem;
    }
    code{
        border-radius: 3px;
        font-size: 1.1rem;
    }
  }
`;

const MarkdownWithCodeBlock = ({ content }) => {
    return (
        <MarkdownContainer>
            <Markdown
                children={content}
                components={{
                    code(props) {
                        const { children, inline, className, node, ...rest } = props
                        const match = /language-(\w+)/.exec(className || '')
                        return !inline && match ? (
                            <SyntaxHighlighter
                                {...rest}
                                PreTag="div"
                                children={String(children).replace(/\n$/, '')}
                                language={match[1]}
                                style={oneDark}
                            />
                        ) : (
                            <code {...rest} className={className}>
                                {children}
                            </code>
                        )
                    }
                }}
            />
        </MarkdownContainer>
    );
};

export default MarkdownWithCodeBlock;
